import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import { formatImage } from '@ifeng/public_method';
import styles from './index.css';
import ColumnTitle from './columnTitle/';
import ColumnTabs from './columnTabs/';
import { rel } from '../../../../../../../utils/rel';

const ColumnBox = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.array,
            title: PropTypes.string,
            mode: PropTypes.string,
            type: PropTypes.string,
            more: PropTypes.string,
        };

        constructor(props) {
            super(props);

            this.state = {
                current: 0,
                rightBarCurrent: 0,
                rightBarDataKey: {
                    ifootball: 'dataYC',
                    nba: 'dataF',
                },
            };
        }

        handleMouseOver = current => {
            this.setState({
                current,
            });
        };

        handleScoreBoardData = (current, dataKey, type) => {
            const { rightBarDataKey } = this.state;

            this.setState({
                rightBarCurrent: current,
                rightBarDataKey: { ...rightBarDataKey, [type]: dataKey },
            });
        };

        renderColumnContent = () => {
            const { mode, content, more } = this.props;
            const { current } = this.state;

            if (mode === 'classicStream') {
                return (
                    <ul className={styles.classicUl}>
                        {content.map((item, index) => {
                            return item.type === 'ad' ? (
                                <li key={index} ref={item.ref} />
                            ) : (
                                <li key={index}>
                                    <div className={styles.stream_left_pic}>
                                        <a href={item.url} target="_blank" rel={rel}>
                                            <img src={item.thumbnail} />
                                        </a>
                                    </div>
                                    <div className={styles.stream_right_content}>
                                        <a href={item.url} target="_blank" rel={rel}>
                                            <p>{item.title}</p>
                                        </a>
                                        {item.source ? <span>{item.source}</span> : null}
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                );
            } else if (mode === 'bigPicFirst') {
                // 将数组第一个提出来
                const firstPos = content.shift();

                return (
                    <div className={styles.bigPicFirstBox}>
                        <div className={styles.gj_football_img}>
                            <a href={firstPos.url} target="_blank" rel={rel}>
                                <img src={formatImage(firstPos.thumbnail, 300, 188)} alt={firstPos.title} />
                            </a>
                            <h3>
                                <a href={firstPos.url} target="_blank" rel={rel}>
                                    {firstPos.describe ? (
                                        <div className={styles.red_box}>{firstPos.describe}</div>
                                    ) : null}
                                    <div
                                        className={styles.bigPic_title}
                                        style={firstPos.describe ? { width: '200px' } : { width: '280px' }}>
                                        {firstPos.title}
                                    </div>
                                </a>
                            </h3>
                        </div>
                        <ul className={styles.gj_football_list}>
                            {content.map((item, index) => (
                                <li key={index}>
                                    <a href={item.url} target="_blank" rel={rel}>
                                        <div className={styles.gj_football_list_l}>
                                            {item.describe ? <h3>{item.describe}</h3> : null}
                                            <p>{item.title}</p>
                                        </div>
                                        <div className={styles.gj_football_list_r}>
                                            <img src={formatImage(item.thumbnail, 80, 70)} />
                                        </div>
                                    </a>
                                    <div className={styles.hoverCurrent} />
                                </li>
                            ))}
                        </ul>
                    </div>
                );
            } else if (mode === 'raceCourse') {
                return (
                    <div className={styles.b2_rt_con}>
                        {content.map((item, index) => (
                            <div
                                key={index}
                                className={`${styles.b2_rt_li} ${current === index ? styles.cur : ''}`}
                                onMouseMove={() => {
                                    this.handleMouseOver(index);
                                }}>
                                <div className={styles.b2_rt_lil}>
                                    <div className={styles.ma_pic}>
                                        <img src={item.homeImg} />
                                    </div>
                                    <p>{item.homeName}</p>
                                </div>
                                <div className={styles.b2_rt_lim}>
                                    <p className={styles.b2_rt_time}>{`${item.date} ${item.time}`}</p>
                                    <p className={styles.b2_rt_vs}>{`${item.homeScore} : ${item.awayScore}`}</p>
                                </div>
                                <div className={styles.b2_rt_lir}>
                                    <div className={styles.ma_pic}>
                                        <img src={item.awayImg} />
                                    </div>
                                    <p>{item.awayName}</p>
                                </div>
                            </div>
                        ))}
                        {more ? (
                            <div className={styles.ck_more}>
                                <a href={more} target="_blank" rel={rel}>
                                    查看更多&gt;
                                </a>
                            </div>
                        ) : null}
                    </div>
                );
            } else if (mode === 'mixRaceCourse') {
                const trueData = content[0] || {};
                const { rightBarDataKey } = this.state;

                return (
                    <div>
                        <ColumnTabs callback={this.handleScoreBoardData} type={this.props.type} />
                        <div className={styles.b2_rt_con}>
                            {trueData[rightBarDataKey.ifootball]
                                ? trueData[rightBarDataKey.ifootball].map((item, index) => (
                                      <div
                                          key={index}
                                          className={`${styles.b2_rt_li} ${current === index ? styles.cur : ''}`}
                                          onMouseMove={() => {
                                              this.handleMouseOver(index);
                                          }}>
                                          <div className={styles.b2_rt_lil}>
                                              <div className={styles.ma_pic}>
                                                  <img src={item.homeImg} />
                                              </div>
                                              <p>{item.homeName}</p>
                                          </div>
                                          <div className={styles.b2_rt_lim}>
                                              <p className={styles.b2_rt_time}>{`${item.date} ${item.time}`}</p>
                                              <p className={styles.b2_rt_vs}>{`${item.homeScore} : ${
                                                  item.awayScore
                                              }`}</p>
                                          </div>
                                          <div className={styles.b2_rt_lir}>
                                              <div className={styles.ma_pic}>
                                                  <img src={item.awayImg} />
                                              </div>
                                              <p>{item.awayName}</p>
                                          </div>
                                      </div>
                                  ))
                                : null}
                            {more ? (
                                <div className={styles.ck_more}>
                                    <a href={more} target="_blank" rel={rel}>
                                        查看更多&gt;
                                    </a>
                                </div>
                            ) : null}
                        </div>
                    </div>
                );
            } else if (mode === 'mixFootBallScoreboard') {
                const allData = content[0] || {};
                const { rightBarDataKey } = this.state;
                const currentTabData = allData[rightBarDataKey.ifootball] || [];

                return (
                    <div>
                        <ColumnTabs type={this.props.type} callback={this.handleScoreBoardData} />
                        <div className={styles.b2_rm_con}>
                            <div className={styles.b2_rm_tb1}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td width="20%">名次</td>
                                            <td width="26%">球队</td>
                                            <td width="17%">场次</td>
                                            <td width="20%">净胜球</td>
                                            <td width="17%">积分</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className={styles.b2_rm_tb2}>
                                <table>
                                    <tbody>
                                        {currentTabData.map((item, index) => (
                                            <tr key={index}>
                                                <td width="20%">
                                                    {index === 0 || index === 1 || index === 2 ? (
                                                        <p>{index + 1}</p>
                                                    ) : (
                                                        index + 1
                                                    )}
                                                </td>
                                                <td width="26%">{item.teamname}</td>
                                                <td width="17%">{item.total}</td>
                                                <td width="20%">{item.goaldiffer}</td>
                                                <td width="17%">{item.score}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {more ? (
                                <div className={styles.ck_more}>
                                    <a href={more} target="_blank" rel={rel}>
                                        查看更多&gt;
                                    </a>
                                </div>
                            ) : null}
                        </div>
                    </div>
                );
            } else if (mode === 'scoreboard') {
                return (
                    <div className={styles.b2_rm_con}>
                        <div className={styles.b2_rm_tb1}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td width="20%">名次</td>
                                        <td width="26%">球队</td>
                                        <td width="17%">场次</td>
                                        <td width="20%">净胜球</td>
                                        <td width="17%">积分</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className={styles.b2_rm_tb2}>
                            <table>
                                <tbody>
                                    {content.map((item, index) => (
                                        <tr key={index}>
                                            <td width="20%">
                                                {index === 0 || index === 1 || index === 2 ? (
                                                    <p>{index + 1}</p>
                                                ) : (
                                                    index + 1
                                                )}
                                            </td>
                                            <td width="26%">{item.teamname}</td>
                                            <td width="17%">{item.total}</td>
                                            <td width="20%">{item.goaldiffer}</td>
                                            <td width="17%">{item.score}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {more ? (
                            <div className={styles.ck_more}>
                                <a href={more} target="_blank" rel={rel}>
                                    查看更多&gt;
                                </a>
                            </div>
                        ) : null}
                    </div>
                );
            } else if (mode === 'mixBasketScoreboard') {
                const allData = content[0] || {};
                const { rightBarDataKey } = this.state;
                const currentTabData = allData[rightBarDataKey.nba] || [];

                return (
                    <div>
                        <ColumnTabs type={this.props.type} callback={this.handleScoreBoardData} />
                        <div className={styles.b2_rm_con}>
                            <div className={styles.b2_rm_tb1}>
                                <table>
                                    <tbody>
                                        <tr>
                                            <td width="20%">名次</td>
                                            <td width="30%">球队</td>
                                            <td width="25%">剩差</td>
                                            <td width="25%">战绩(胜/负)</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className={styles.b2_rm_tb2}>
                                <table>
                                    <tbody>
                                        {currentTabData.map((item, index) => (
                                            <tr key={index}>
                                                <td width="20%">
                                                    {index === 0 || index === 1 || index === 2 ? (
                                                        <p>{index + 1}</p>
                                                    ) : (
                                                        index + 1
                                                    )}
                                                </td>
                                                <td width="30%">{item.teamname}</td>
                                                <td width="25%">{item.gb}</td>
                                                <td width="25%">{`${item.win}/${item.lose}`}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {more ? (
                                <div className={styles.ck_more}>
                                    <a href={more} target="_blank" rel={rel}>
                                        查看更多&gt;
                                    </a>
                                </div>
                            ) : null}
                        </div>
                    </div>
                );
            } else if (mode === 'zBasketScoreboard') {
                return (
                    <div className={styles.b2_rm_con}>
                        <div className={styles.b2_rm_tb1}>
                            <table>
                                <tbody>
                                    <tr>
                                        <td width="20%">名次</td>
                                        <td width="30%">球队</td>
                                        <td width="25%">剩差</td>
                                        <td width="25%">战绩(胜/负)</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className={styles.b2_rm_tb2}>
                            <table>
                                <tbody>
                                    {content.map((item, index) => (
                                        <tr key={index}>
                                            <td width="20%">
                                                {index === 0 || index === 1 || index === 2 ? (
                                                    <p>{index + 1}</p>
                                                ) : (
                                                    index + 1
                                                )}
                                            </td>
                                            <td width="30%">{item.teamname}</td>
                                            <td width="25%">{item.ratio}</td>
                                            <td width="25%">{`${item.win}/${item.lose}`}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        {more ? (
                            <div className={styles.ck_more}>
                                <a href={more} target="_blank" rel={rel}>
                                    查看更多&gt;
                                </a>
                            </div>
                        ) : null}
                    </div>
                );
            }

            return null;
        };

        render() {
            const { title } = this.props;

            return (
                <div className={styles.columnBox}>
                    <ColumnTitle title={title} />
                    {this.renderColumnContent()}
                </div>
            );
        }
    },
);

export { ColumnBox };
export default ColumnBox;
